import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '../../lib/supabase';
import { useLocation } from 'react-router-dom';

interface LoginFormProps {
  redirectTo?: string;
}

export function LoginForm({ redirectTo }: LoginFormProps) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  
  // Determine the final destination path after successful login and callback
  // Priority: URL Param -> localStorage (as fallback) -> Prop -> Default
  const returnTo = searchParams.get('returnTo') ||
                  localStorage.getItem('authReturnPath') || // Keep localStorage as a fallback for now, but prioritize URL param
                  redirectTo ||
                  '/';

  // Check if user wants to sign up or sign in
  const viewMode = searchParams.get('view') === 'signup' ? 'sign_up' : 'sign_in';
  const isSignUp = viewMode === 'sign_up';

  // Force absolute URL for the callback to ensure it works correctly
  const callbackUrl = new URL('/auth/callback', window.location.origin).toString();
  
  // Store the returnTo path in localStorage and sessionStorage for redundancy
  if (returnTo && returnTo !== '/') {
    console.log('Storing return path before login:', returnTo);
    
    // Store information about the intended destination
    const pathData = {
      returnPath: returnTo,
      timestamp: new Date().toISOString()
    };
    
    localStorage.setItem('authReturnPath', returnTo);
    localStorage.setItem('authReturnPathData', JSON.stringify(pathData));
    sessionStorage.setItem('preLoginReturnPath', returnTo);
  }

  // Debug log
  console.log('Auth redirect configuration:', {
    returnTo,
    callbackUrl,
    currentLocation: window.location.href,
    searchParams: Object.fromEntries(searchParams.entries()),
    viewMode,
    timestamp: new Date().toISOString()
  });

  return (
    <div className="w-full max-w-md mx-auto p-6 space-y-4">
      <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center mb-6 text-gray-900 dark:text-white">
          {isSignUp ? 'Create Account' : 'Welcome Back'}
        </h2>
        <Auth
          supabaseClient={supabase}
          view={viewMode}
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: '#404040',
                  brandAccent: '#22c55e',
                },
              },
            },
          }}
          providers={['google']}
          redirectTo={callbackUrl}
          magicLink={false}
        />
      </div>
    </div>
  );
} 
